import { Hero } from '@/components/sections/Hero';
import { SkillsShowcase } from '@/components/sections/SkillsShowcase';
import { WorkAndStack } from '@/components/sections/WorkAndStack';
import type { Bootstrap } from '@/lib/types';

export function HomePage({ data }: { data: Bootstrap }) {
  return (
    <>
      <Hero
        profile={data.profile}
        socialLinks={data.socialLinks}
        projectCount={data.projects.length}
      />

      <div className="shell">
        <div className="rule" />
      </div>

      <WorkAndStack projects={data.projects} skills={data.skills} />

      <div className="shell">
        <div className="rule" />
      </div>

      <SkillsShowcase skills={data.skills} />
    </>
  );
}
